import { transitionTreatmentSession } from "./authorityApi";
import { TREATMENT_RUNTIME_ACTION } from "./treatmentApiConstants";

export const continueWithEligiblePrograms = async ({
  session,
  eligibleProgramIds,
  acknowledgedExclusions,
  availabilityDecisionIds,
}) => {
  if (!session) throw new Error("Treatment session is unavailable.");
  return transitionTreatmentSession(
    session,
    TREATMENT_RUNTIME_ACTION.continueWithEligiblePrograms,
    {
      eligible_program_ids: (eligibleProgramIds || []).map(String),
      acknowledged_exclusions: (acknowledgedExclusions || []).map(String),
      availability_decision_ids: (availabilityDecisionIds || []).map(String),
    },
  );
};
